import { render, staticRenderFns } from "./SavedPostsModule.vue?vue&type=template&id=aaebd4f2&scoped=true"
import script from "./SavedPostsModule.vue?vue&type=script&lang=js"
export * from "./SavedPostsModule.vue?vue&type=script&lang=js"
import style0 from "./SavedPostsModule.vue?vue&type=style&index=0&id=aaebd4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaebd4f2",
  null
  
)

export default component.exports